/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".password-matcher-message[_ngcontent-%COMP%]{font-size:.75rem;color:#e93525;display:block;text-align:right;visibility:hidden;-webkit-transition:.5s ease-in-out,max-height .25s ease-in-out;transition:all .5s ease-in-out 0s,max-height .25s ease-in-out 0s;opacity:0}.password-matcher-message.active[_ngcontent-%COMP%]{visibility:visible;opacity:1}.field[_ngcontent-%COMP%]:not(:last-child){margin-bottom:2.5rem}"];
export { styles as styles };
